import type { DataNode } from 'components/WorkspaceEditor/types'

/**
 * Checks if value Text elements exist after a FieldRef in the node's content items.
 * Multi-element PTs have separate PlainText instances for value text after the FieldRef,
 * while single-element PTs render the value via DesignationField's suffix.
 */
export const hasValueTextAfterFieldRef = (
    contentItemNodes?: DataNode['contentItemNodes']
): boolean => {
    if (!contentItemNodes) return false
    const fieldRefIdx = contentItemNodes.findIndex((n) => n.type === 'FieldRef')
    if (fieldRefIdx === -1) return false
    return contentItemNodes.some(
        (item, idx) => idx > fieldRefIdx && item.type === 'Text'
    )
}

interface IsDesignationSuffixEditOptions {
    isProductType?: boolean
    isFirstElement: boolean
    isKeyedText: boolean
    contentItemNodes?: DataNode['contentItemNodes']
}

/**
 * Determines if a single-element PT in designation mode should re-prepend the key on save.
 * When EditorContent strips the key from CKEditor (isPTKey is true),
 * only the value is editable. On save, the key must be re-prepended.
 */
export const isDesignationSuffixEdit = ({
    isProductType,
    isFirstElement,
    isKeyedText,
    contentItemNodes,
}: IsDesignationSuffixEditOptions): boolean => {
    return Boolean(
        isProductType &&
            isFirstElement &&
            isKeyedText &&
            !hasValueTextAfterFieldRef(contentItemNodes)
    )
}
